export const WIDGET_SPACING_HUGE = 80;
export const WIDGET_SPACING_LARGE = 60;
export const WIDGET_SPACING_MEDIUM = 50;
export const WIDGET_SPACING_SMALL = 30;

export const TEXT_WIDTH = 720;
export const TEXT_WIDTH_NARROW = 600;
